export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const REACT_APP_SHRAVAN_BASE_URL = process.env.REACT_APP_SHRAVAN_BASE_URL;

export const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const LOGIN  = REACT_APP_BASE_URL +  '/auth/login';
export const SIGNUP = REACT_APP_BASE_URL + '/auth/signup';
export const GOOGLE_LOGIN = REACT_APP_BASE_URL + '/auth/googleLogin';

export const SEND_OTP = REACT_APP_BASE_URL + '/auth/sendOtp';
export const VALIDATE_OTP = REACT_APP_BASE_URL + '/auth/validate';
export const VALIDATE_OTP_LOGIN = REACT_APP_BASE_URL + '/auth/otpLogin'; 


export const REQUEST_ACCESS = REACT_APP_BASE_URL + '/auth/requestAccess';

export const GET_USER_INFO = REACT_APP_BASE_URL +  '/user/getUserInfo';
export const GET_USERNAME = REACT_APP_BASE_URL + '/user/getUsername'
export const GET_ACCOUNT_INFO = REACT_APP_BASE_URL +  '/user/getAccountInfo';
export const PATCH_USER_INFO = REACT_APP_BASE_URL +  '/user/patchUser';
export const PATCH_ACCOUNT_INFO = REACT_APP_BASE_URL +  '/user/patchAccountInfo';
export const RESET_USER_PASSWORD = REACT_APP_BASE_URL +  '/auth/resetPassword';
export const FORGOT_PASSWORD = REACT_APP_BASE_URL + '/auth/forgotPassword';
export const RESET_PASSWORD_TOKEN = REACT_APP_BASE_URL + '/auth/resetPasswordToken';
export const VERIFY_EMAIL_TOKEN = REACT_APP_BASE_URL + '/auth/verifyEmailToken';


export const GET_BOOKS = REACT_APP_BASE_URL +  '/user/getBooks';
export const GET_TELANGANA_BOOKS = REACT_APP_BASE_URL +  '/user/getTelanganaBooks';
export const GET_BOOKS_BY_CAT  = REACT_APP_BASE_URL +  '/user/getBooksByCat';
export const SAVE_BOOK_IN_SELF = REACT_APP_BASE_URL +  '/user/saveBook';
export const  ADD_BOOK_FROMAT = REACT_APP_BASE_URL +  '/user/requestFormat';
export const GET_SAVED_BOOKS = REACT_APP_BASE_URL +  '/user/getSavedBooks';


export const UPLOAD_FILE_WITH_USER_INFO = REACT_APP_BASE_URL + '/org/uploadFileWithUsers'; 

export const APPORVAL_REQUEST = REACT_APP_BASE_URL + '/org/approval';

export const ADD_BOOK_REVIEW = REACT_APP_BASE_URL + '/book/addReview';
export const GET_USER_REVIEW = REACT_APP_BASE_URL + '/book/userReview';
export const GET_ALL_COMMENTS = REACT_APP_BASE_URL + '/book/allComments';


export const GET_ALL_ACCESSIBLE_DOCS = REACT_APP_BASE_URL + '/accessibility/documents';
export const GET_ALL_ACCESSIBLE_MEDIA = REACT_APP_BASE_URL + '/accessibility/mediaDocs';
export const ADD_MEDIA_FILE = REACT_APP_BASE_URL + '/accessibility/convertMedia';
export const ADD_DOC_FILE = REACT_APP_BASE_URL + '/accessibility/convertDocument';
export const ASK_BENEFITS_BOT = REACT_APP_BASE_URL + '/infoAccess/askBenefitsBot';
export const ASK_JOB_COACH = REACT_APP_BASE_URL + '/infoAccess/askJobCoach';
export const PARSE_RESUME = REACT_APP_BASE_URL + '/infoAccess/parseResume';
export const DELETE_RESUME = REACT_APP_BASE_URL + '/infoAccess/resume';
export const PARSE_LINKEDIN = REACT_APP_BASE_URL + '/infoAccess/parseLinkedIn';

export const FETCH_BENEFITS_CHATS = REACT_APP_BASE_URL + '/infoAccess/fetchBenefitsChats';
export const START_BENEFITS = REACT_APP_BASE_URL + '/infoAccess/benefits/start';
export const FETCH_JOB_CHATS = REACT_APP_BASE_URL + '/infoAccess/fetchJobChats';
export const FETCH_ALL_JOBS = REACT_APP_BASE_URL + '/jobs/allJobs';
export const FETCH_RECOMMENDED_JOBS = REACT_APP_BASE_URL + '/jobs/allJobs/recommended';
export const APPLY_FOR_JOB = REACT_APP_BASE_URL + '/jobs/apply/{jobId}';

export const LINK_YOUR_PHONE = REACT_APP_BASE_URL + '/auth/linkPhoneNumber';
export const LINK_USING_TOKEN = REACT_APP_BASE_URL + '/auth/linkAccountToken';
export const LINK_EMAIL_OR_PHONE = REACT_APP_BASE_URL + '/auth/linkUserAccount';

export const WHITELIST_SINGLE_NUMBER = REACT_APP_BASE_URL + '/whitelisting/whitelistSingleNumber';
export const WHITELIST_MULTIPLE_NUMBERS = REACT_APP_BASE_URL + '/whitelisting/whitelistNumbers';
export const WHITELIST_SINGLE_EMAIL = REACT_APP_BASE_URL + '/whitelisting/whitelistSingleEmail';
export const WHITELIST_MULTIPLE_EMAILS = REACT_APP_BASE_URL + '/whitelisting/whitelistEmails';

export const GET_LATEST_NEWS = REACT_APP_BASE_URL + '/news/get-latest-news';
export const GET_LATEST_NEWS_FILTERED = REACT_APP_BASE_URL + '/news/latest-news/filtered';
export const GET_LATEST_NEWS_BY_SOURCE = REACT_APP_BASE_URL + '/news/latest-news/source';
export const GET_NEWS_CATEGORY = REACT_APP_BASE_URL + '/news/news-category';
export const GET_NEWS_SOURCE = REACT_APP_BASE_URL + '/news/news-sources';
export const GET_NEWS_BULLETIN_LIST = REACT_APP_BASE_URL + '/news/get-news-bulletin-list';
export const GET_NEWS_BULLETIN = REACT_APP_BASE_URL + '/news/get-news-bulletin';
